import { ForwardedRef, ReactNode, forwardRef } from "react";
import classNames from "classnames";

/** The `Menu` component properties.  */
export interface MenuProps {

  /** Indicates whether the menu is expanded or not. */
  readonly expanded: boolean;

  /** The component children. */
  readonly children?: ReactNode;
}

/** The menubar menu. */
export const Menu = forwardRef((props: MenuProps, ref: ForwardedRef<HTMLDivElement>): ReactNode => {
  const { expanded, children } = props;
  const className = classNames("menu", { expanded });

  return (
    <div ref={ref} tabIndex={-1} className={className}>
      {children}
    </div>
  );
});
